import Vue from 'vue'
import 'chartist/dist/chartist.min.css'
require('chartist-plugin-tooltip');
Vue.use(require('vue-chartist'))
